import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M40 51.667H25c-4.652 0-6.979 0-8.871.574A13.333 13.333 0 0 0 7.24 61.13c-.574 1.892-.574 4.218-.574 8.87m46.667-10 6.666 6.667 13.334-13.334M48.333 25c0 8.284-6.716 15-15 15-8.285 0-15-6.716-15-15 0-8.284 6.715-15 15-15 8.284 0 15 6.716 15 15z",
      stroke: "currentColor",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }